import { render, staticRenderFns } from "./datatable.vue?vue&type=template&id=543adfc0&scoped=true&"
import script from "./datatable.vue?vue&type=script&lang=js&"
export * from "./datatable.vue?vue&type=script&lang=js&"
import style0 from "./datatable.vue?vue&type=style&index=0&id=543adfc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543adfc0",
  null
  
)

export default component.exports